import React, {Component} from 'react';
import {Button, Col, Image, Modal, Row} from 'react-bootstrap';
import Loader from '../Loader';
import reactCSS from 'reactcss';
import {SketchPicker} from 'react-color';
import Colour_Picker from '../../components/Colour_Picker';


class SuggestDesignsModal extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			data : [],
			page : 0,
			computing: false,
			fontLock : false,
			colorColor : false,
			seedColor1: '#7cadf7',
			seedColor2: '#e6a45a',
			displayColorPicker1: false,
			displayColorPicker2: false
		}
	}

	componentDidUpdate (prev_props){
		if(!prev_props.show_suggest_design_modal && this.props.show_suggest_design_modal && window.design_editor){
			var colors = window.design_editor.design.findDominantColors();

			var updates = {data:[]}

			if(colors[0]){
				updates.seedColor1 = colors[0]
			}

			if(colors[1]){
				updates.seedColor2 = colors[1]
			}

			this.setState(updates)
		}

		if(prev_props.show_suggest_design_modal && !this.props.show_suggest_design_modal){
			this.setState({computing: false});
		}
	}

	editor = new window.designEditor({"pages":[{"background_color":"rgba(255,255,255,1)","objects":[]}]},[window.document.createElement('div')],undefined,true);


	styleOnClick = (resource) => {
		if (!this.props.triggerSubscriptionWall) {
			window.design_editor.load(resource.file);
			window.design_editor.addUndoChange();
			this.props.hide_suggest_design_modal();
		}
		else {
			this.props.hide_suggest_design_modal();
			this.props.triggerSubscriptionWall(true);
		}
	};

	set_state = async state => new Promise(resolve => this.setState(state, resolve));

	handleClick1 = () => {
        this.setState({ displayColorPicker1: !this.state.displayColorPicker1 })
    };
    
    handleClose1 = () => {
        this.setState({ displayColorPicker1: false })
    };

    handleClick2 = () => {
        this.setState({ displayColorPicker2: !this.state.displayColorPicker2 })
    };
    
    handleClose2 = () => {
        this.setState({ displayColorPicker2: false })
    };

	applyChanges = async () => {
		try{
			if(this.state.computing){
				return;
			}

			await this.set_state({computing: true})
			await this.set_state({data: []})
			this.editor.undo_stack_disabled = true;

			if(!this.state.fontLock){
	            var old_data = window.design_editor.save();
	            this.editor.load(old_data);
	            this.editor.draw();
	            var data = []
				for (var i = 0; i < 29; i++) {
					await this.editor.fontSwap(i)
					if(!this.state.colorLock){
						await this.editor.colorSwap(i,[this.state.seedColor1,this.state.seedColor2])
					}
					this.editor.set_redraw_all_objects('text')
					this.editor.draw();
					await Promise.all(this.editor.resource_promise_array)
					var src = this.editor.pages[0].export('low')

					this.setState({data: this.state.data.concat([{src: src,file: this.editor.save()}])} )
				}
	            
			}

			if(!this.state.colorLock && this.state.fontLock){
				var old_data = window.design_editor.save();
				this.editor.load(old_data);
	            this.editor.draw();
				await Promise.all(this.editor.resource_promise_array)
				for(var i = 0; i < 29; i++){
					await this.editor.colorSwap(i,[this.state.seedColor1,this.state.seedColor2])
					var src = this.editor.pages[0].export('low')
					this.setState({data: this.state.data.concat([{src: src,file: this.editor.save()}])} )
				}
			}

			await this.set_state({computing: false})
		}catch(err){
			console.log(err);
		}
	}

	render() {
		const styles1 = reactCSS({
            'default': {
              color: {
                width: '30px',
                height: '30px',
                borderRadius: '15px',
                'border': '1px solid #ababab',
                background: this.state.seedColor1
              },
              swatch: {
                padding: '2.5px',
                borderRadius: '15px',
                display: 'inline-block',
                cursor: 'pointer',
              },
              popover: {
                position: 'absolute',
                zIndex: '2',
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: '-1'
              },
            },
        });

		const styles2 = reactCSS({
            'default': {
              color: {
                width: '30px',
                height: '30px',
                borderRadius: '15px',
                'border': '1px solid #ababab',
                background: this.state.seedColor2
              },
              swatch: {
                padding: '2.5px',
                borderRadius: '15px',
                display: 'inline-block',
                cursor: 'pointer',
              },
              popover: {
                position: 'absolute',
                zIndex: '2',
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: '-1'
              },
            },
        });
		return (
			<Modal show={this.props.show_suggest_design_modal} onHide={this.props.hide_suggest_design_modal} bsSize="large">
            <Modal.Header closeButton>
                <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 'bold'}}>Auto Suggest</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            	<Row>
            		<Col xs={3}>
            			<Button className="btn-block btn-orange" onClick={() => this.setState({fontLock : !this.state.fontLock})}>
		            		<span className="pull-left">Font</span>
		            		<span className={this.state.fontLock?"fa fa-lock pull-right":"fa fa-lock-open pull-right"}/>
		            	</Button>
            		</Col>
            		<Col xs={3}  style={{display:'flex',flexFlow: 'col'}}>
		            	<Button className="btn-block btn-orange" onClick={() => this.setState({colorLock : !this.state.colorLock})}>
		            		<span className="pull-left">Colors</span>
		            		<span className={this.state.colorLock?"fa fa-lock pull-right":"fa fa-lock-open pull-right"}/>
		            	</Button>
		            	<div>
	                        <div style={ styles1.swatch } onClick={ this.handleClick1 }>
	                        <div style={ styles1.color } />
	                        </div>
	                        { this.state.displayColorPicker1 ? <div style={ styles1.popover }>
	                        <div style={ styles1.cover } onClick={ this.handleClose1 }/>
	                        <Colour_Picker user={this.props.user} presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} disableAlpha={true} color={this.state.seedColor1} onChange={ (e) => {this.setState({seedColor1: e.hex}) }} />
	                        </div> : null }
	                    </div>
	                    <div>
	                        <div style={ styles2.swatch } onClick={ this.handleClick2 }>
	                        <div style={ styles2.color } />
	                        </div>
	                        { this.state.displayColorPicker2 ? <div style={ styles2.popover }>
	                        <div style={ styles2.cover } onClick={ this.handleClose2}/>
	                        <Colour_Picker user={this.props.user}  presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} disableAlpha={true} color={this.state.seedColor2} onChange={ (e) => {this.setState({seedColor2: e.hex}) }} />
	                        </div> : null }
	                    </div>
            		</Col>
            		<Col className="text-right" xs={6}>
		            	<Button disabled={this.state.computing} onClick={this.applyChanges} className="btn-orange">
		            		Apply Changes
		            	</Button>
            		</Col>
            	</Row>
            	<Row>
	            	{this.state.computing?(
	            		<Col xs={12}>
	            			<div  style={{ width:'100%', height:300}}>
	            				<Loader show_loader={true} style={{}} />
	            			</div>
	            			
	            		</Col>
            		):this.state.data.map(data => (
	            		<Col xs={4} style={{textAlign: 'center'}}>
	            			<div onClick={() => this.styleOnClick(data)} style={{cursor: 'pointer',height: 250, width: 250, margin: 'auto', backgroundColor: '#f1f2f3', marginTop: 10, verticalAlign: 'middle', display: 'inline-flex'}}>
	            				<Image style={{maxHeight: 250, margin: 'auto', display: 'block', verticalAlign: 'middle', maxWidth: '100%', objectFit: 'contain'}} src={data.src} />
	            			</div>
	            		</Col>
	            	))}
            	</Row>
            </Modal.Body>
            <Modal.Footer>
                <div></div>
            </Modal.Footer>
        </Modal>);
	}
}

export default SuggestDesignsModal;